module.exports = function (app, mod, stream_id) {
  var videoAttribute = '';
  var imgsrc = stream_id ? app.keychain.returnIdenticon(stream_id) : '';
  if (stream_id === 'local') {
    imgsrc = app.keychain.returnIdenticon(mod.publicKey);
    videoAttribute = 'muted';
  }
  return "\n     <div class=\"audio-box\" id=\"audiostream_".concat(stream_id, "\">\n      <audio autoplay ").concat(videoAttribute, " playsinline id=\"").concat(stream_id, "\"></audio>\n      <img data-id=\"").concat(stream_id, "\" class=\"saito-identicon\" src=\"").concat(imgsrc, "\"/>\n     </div>\n     ");
};